exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".ring-tooltip-ng.ring-tooltip-ng{text-align:left}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/src?{}!./node_modules/sass-loader/lib/loader.js?sourcemap&outputStyle=expanded!./src/blocks/ring-tooltip-ng/ring-tooltip-ng.scss
// module id = 525
// module chunks = 0